import moment from "moment-timezone";

export const pickIntervals = (intervals: any[] | undefined, isAvailable: boolean) =>
    (intervals || []).filter(
        (interval) => interval?.from && interval?.to && (typeof interval.available !== "boolean" || interval.available === isAvailable),
    );

export const getDates = (from: moment.MomentInput, to: moment.MomentInput) => {
    const dates: string[] = [];
    let current = moment(from);
    const end = moment(to);
    while (current.isSameOrBefore(end, "day")) {
        dates.push(current.format("YYYY-MM-DD"));
        current = current.clone().add(1, "day");
    }
    return dates;
};
